(function () {
  console.log("🔥 KW Monitor Timer Activated");

  let lastIndoor = 0;
  let lastOutdoor = 0;
  let alerted = false;

  function extractUnitsAndKW(str) {
    const entries = str.split(",").map(s => s.trim());
    let indoorKW = 0;
    let outdoorKW = 0;

    entries.forEach(entry => {
      // 提取数量，例如 5 x HINRP20MB-2.0KW
      let quantity = 1;
      let text = entry;

      const qtyMatch = entry.match(/^(\d+)\s*x\s*/i);
      if (qtyMatch) {
        quantity = parseInt(qtyMatch[1], 10);
        text = entry.replace(qtyMatch[0], "").trim(); // 移除数量前缀
      }

      // 提取功率
      const kwMatch = text.match(/(\d+(\.\d+)?)\s*KW/i);
      const kw = kwMatch ? parseFloat(kwMatch[1]) : 0;

      // 分类为 indoor 或 outdoor
      if (/MON/i.test(text)) {
        outdoorKW += kw * quantity; // Outdoor 默认只有一项，但支持乘以 1
      } else if (
        /HINRP/i.test(text) ||
        /DINSD/i.test(text) ||
        /CIN0/i.test(text) ||
        /\bFINRP50MB\b/i.test(text)
      ) {
        indoorKW += kw * quantity;
      }
    });

    return { indoorKW, outdoorKW };
  }

  function checkKWLimit() {
    const allSwatches = document.querySelectorAll('.po-selected-swatch .swatch_value.po-value');

    let indoorKW = 0;
    let outdoorKW = 0;

    allSwatches.forEach((el) => {
      const text = el.textContent.trim();
      const result = extractUnitsAndKW(text);
      indoorKW += result.indoorKW;
      outdoorKW += result.outdoorKW;
    });

    if (indoorKW !== lastIndoor || outdoorKW !== lastOutdoor) {
      console.log(`🧊 Indoor Total: ${indoorKW} KW`);
      console.log(`🔥 Outdoor Total: ${outdoorKW} KW`);

      lastIndoor = indoorKW;
      lastOutdoor = outdoorKW;

      if (indoorKW > outdoorKW && outdoorKW > 0 && !alerted) {
        // alert(`⚠️ Indoor Units ${indoorKW} KW Exceeds Outdoor Unit ${outdoorKW} KW!`);
            Swal.fire({
            icon: 'warning',
            title: 'Power Mismatch Detected',
            html: `⚠️Indoor Units <b><span style="color:red">${indoorKW}</span></b> KW</span></b><br>Exceeds Outdoor Unit Capacity of <b><span style="color:green">${outdoorKW}</span></b> KW .`,
            footer: 'Please reduce the total indoor capacity or upgrade the outdoor unit.',
            confirmButtonText: 'Got it!',
            confirmButtonColor: '#3F72E5',
            width: 450
          });

        alerted = true;
      }

      if (indoorKW <= outdoorKW) {
        alerted = false;
      }
    }
  }

  setInterval(checkKWLimit, 1000); // 每秒检查
})();
